import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Dashboard from './pages/Dashboard';
import TVDisplay from './pages/TVDisplay';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tv" element={<TVDisplay />} />
        <Route path="/tv/:locationIndex" element={<TVDisplay />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
